const klaviyoForm = document.querySelector('.klaviyo-form-TdL3D8');
if (klaviyoForm) {
	const config = {
		attributes: true,
		childList: true,
		subtree: true,
	};
	let checkboxValues = [];
	const observer = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				observer.disconnect();
				setTimeout(() => {
					const checkboxes = klaviyoForm.querySelectorAll('input[type="checkbox"]');
					if (checkboxes.length > 0) {
						checkboxes.forEach((checkbox) => {
							checkbox.addEventListener('change', () => {
								checkboxValues = Array.from(
									document.querySelectorAll('input[type="checkbox"]:checked'),
									(el) => el.labels[0].innerText,
								);
								sessionStorage.setItem('b2bFormValues', JSON.stringify(checkboxValues));
							});
						});
					}
				}, 250);
			}
		}
	});

	observer.observe(klaviyoForm, config);
	window.addEventListener('klaviyoForms', (event) => {
		if (event.detail.type === 'submit' && event.detail.formId === 'TdL3D8') {
			const b2bFormValues = sessionStorage.getItem('b2bFormValues');
			window.dataLayer.push({
				event: 'gaEvent',
				eventCategory: 'B2B-form',
				eventAction: 'submission_successful',
				eventLabel: {
					context: JSON.stringify(b2bFormValues),
				},
			});
			sessionStorage.setItem('b2bFormValues', '');
		}
	});
}
